import { render } from "./manage-stocks.vue?vue&type=template&id=1cf36453"
import script from "./manage-stocks.vue?vue&type=script&lang=js"
export * from "./manage-stocks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__